@if (inputData?.type !== 'quote') {
  <div
    class="modal-content border-0 cnt-dashboard border-r2"
    data-backdrop="static"
  >
    <form
      (ngSubmit)="(cateogryForm.form.valid)"
      #cateogryForm="ngForm"
      novalidate
    >
      <div
        class="modal-body bg-gris-1 p-5 d-flex align-items-center flex-column"
      >
        <h2 class="text-1 fs-4 text-center mb-4">
          {{
            inputData?.label === 'Address'
              ? ('COMMON.Update Address Name' | translate)
              : ((inputData?.label === 'phone_name'
                  ? ('COMMON.Update Phone Name' | translate)
                  : inputData?.name
                    ? ('ITEMS.Update Category' | translate)
                    : ('COMMON.ADDNEWCATEGORY' | translate)
                ) | translate)
          }}
        </h2>
        <i
          type="button"
          #closebutton
          class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeDialog()"
        ></i>
        <input
          matInput
          class="form-control p-2 text-center w-75"
          type="text"
          [placeholder]="'QUOTE_TEMPLATE.Enter Category' | translate"
          [(ngModel)]="categoryAddModel.name"
          name="name"
          #name="ngModel"
          required
        />
        @if (name.invalid && throwError) {
          <div class="alert error_message mb-0">
            @if (throwError) {
              <div>
                {{ 'COMMON.ERRORNAMEREQUIRED' | translate }}
              </div>
            }
          </div>
        }
        @if (inputData.itemsEditButtonId == 'categoryId') {
          <button
            class="btn btn-1 mt-4 py-2"
            (click)="addCateogry(cateogryForm)"
          >
            <i class="fa fa-plus"></i>&nbsp;&nbsp;{{ 'COMMON.Add' | translate }}
          </button>
        }
        @if (inputData.itemsEditButtonId !== 'categoryId' && !inputData.label) {
          <button
            class="btn btn-1 mt-4 py-2"
            (click)="updateCateogry(cateogryForm)"
          >
            {{ 'COMMON.UPDATE' | translate }}
          </button>
        }
        @if (inputData.itemsEditButtonId !== 'categoryId' && inputData.label) {
          <button
            class="btn btn-1 mt-4 py-2"
            (click)="updateAddress(cateogryForm)"
          >
            {{ 'COMMON.UPDATE' | translate }}
          </button>
        }
      </div>
    </form>
  </div>
}

@if (inputData?.type == 'quote') {
  <div
    class="modal-content border-0 cnt-dashboard border-r2"
    data-backdrop="static"
  >
    <form
      (ngSubmit)="(cateogryForm.form.valid)"
      #cateogryForm="ngForm"
      novalidate
    >
      <div
        class="modal-body bg-gris-1 p-5 flex items-center flex-col xs-11:!p-0"
      >
        <h2 class="text-1 fs-4 text-center mb-4">
          {{
            getTranslatedText('QUOTE_TEMPLATE.' + inputData?.title) ||
              inputData?.title
          }}
        </h2>
        <i
          type="button"
          #closebutton
          class="color-4 fs-2 far fa-times-circle position-absolute end-0 top-0 m-3"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeDialog()"
        ></i>
        <input
          matInput
          class="form-control p-2 text-center w-75"
          type="text"
          [placeholder]="'COMMON.Enter Name' | translate"
          [(ngModel)]="categoryAddModel.name"
          name="name"
          #name="ngModel"
          required
        />
        @if (name.invalid && throwError) {
          <div class="alert error_message mb-0">
            @if (throwError) {
              <div>
                {{ 'COMMON.ERRORNAMEREQUIRED' | translate }}
              </div>
            }
          </div>
        }
        @if (
          inputData.title == 'UPDATE TITLE' || inputData.title == 'ADD TITLE'
        ) {
          @if (
            inputData.title == 'ADD TITLE' && inputData.title !== 'UPDATE TITLE'
          ) {
            <button
              class="btn btn-1 mt-4 py-2"
              (click)="addTitle(cateogryForm)"
            >
              <i class="fa fa-plus"></i>&nbsp;&nbsp;{{
                'COMMON.Add' | translate
              }}
            </button>
          }
          @if (
            inputData.title !== 'ADD TITLE' && inputData.title == 'UPDATE TITLE'
          ) {
            <button
              style="padding-right: 18px"
              class="btn btn-1 mt-4 py-2"
              (click)="updateTitle(cateogryForm)"
            >
              {{ 'COMMON.UPDATE' | translate }}
            </button>
          }
        }

        @if (
          inputData.title == 'UPDATE NAME' || inputData.title == 'ADD METHOD'
        ) {
          @if (
            inputData.title == 'ADD METHOD' && inputData.title !== 'UPDATE NAME'
          ) {
            <button
              class="btn btn-1 mt-4 py-2"
              (click)="addTitle(cateogryForm)"
            >
              <i class="fa fa-plus"></i>&nbsp;&nbsp;{{
                'COMMON.Add' | translate
              }}
            </button>
          }
          @if (
            inputData.title !== 'ADD METHOD' && inputData.title == 'UPDATE NAME'
          ) {
            <button
              class="btn btn-1 mt-4 py-2"
              (click)="updateTitle(cateogryForm)"
            >
              {{ 'COMMON.UPDATE' | translate }}
            </button>
          }
        }
      </div>
    </form>
  </div>
}
